module.exports = __webpack_public_path__ + "files/07979e0db9c32de2acbf992ff2b1ebda.png";